import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython, faApple, faAndroid } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React Native",
    "Zustand",
    "Node.js",
    "Postgres SQL",
    "Firebase",
    "Supabase",
    "GraphQL",
    "PostgreSQL",
    "Tailwind CSS",
    "NativeWind",
    "Jest",
    "Detox",
];

const labelsSecond = [
    "React",
    "JavaScript",
    "Next.js",
    "Node.js",
    "Zustand",
    "Postgres SQL",
    "Firebase",
    "Supabase",
    "GraphQL",
    "PostgreSQL",
    "Tailwind CSS",
    "NativeWind",
    "Jest",
    "Detox",
];

const labelsThird = [
    "OpenAI",
    "Groq",
    "LangChain",
    "Qdrant",
    "Hugging Face",
    "LlamaIndex",
    "Streamlit",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                <FontAwesomeIcon icon={faApple} size="3x" style={{ marginRight: '10px' }}/>
                <FontAwesomeIcon icon={faAndroid} size="3x"/>
                    <h3>Mobile Development</h3>
                    <p>
                    I specialize in building high-performance mobile applications from scratch using React Native. Experienced in state management, UI/UX optimization, backend integration, and end-to-end testing to ensure seamless functionality.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Web Development</h3>
                    <p>I am a full-stack web developer specializing in React, delivering comprehensive frontend and backend solutions. Skilled in managing the entire software development lifecycle to build robust and scalable web applications.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>GenAI & LLM</h3>
                    <p>Stay relevant in the market by leveraging the latest AI models in your projects. I have professional experience building enterprise grade GenAI-enabled solutions to empower intelligent decision making.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;